/** @module csi/widget/_svg/AddPageDropDownMenuItem */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"dojo/text!./resources/AddPageDropDownMenuItem.html"
], function(declare, _WidgetBase, _TemplatedMixin, template){
	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		// label for each menu item
		label: "",

		// node for label
		labelNode: null,

		/**
		 * onClick extension point
		 */
		onClick: function() { },

		/**
		 * click event for menu item
		 */
		_onClick: function() {
			this.onClick();
		},
	});
});
